/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import UsuarioCursoForm from './UsuarioCursoForm';
import * as validations from '../../validations/validations';
import * as usuariocursoActions from '../../actions/usuariocursoActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as userActions from '../../actions/userActions';
import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';
import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
import $ from 'jquery';
import dayjs from 'dayjs';

class ManageUsuarioCursoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            constancia:{},
            permisos:{},
			usuariocurso:{
                fechaCurso: new moment().format('DD/MM/YYYY'),    
                    }
		};
		
	}
    
    
    componentDidMount(){
        
       
        
        /*
        let pageInfo={ 
            page:'usuariocurso', 
            idioma:this.props.idioma     
        }; 
        this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        });
        
        
        */
        
        usuarioActual(this, "usuariocurso",true).then( (usuario)=>{
        
            let id=this.props.id;

            if(id && id>0 ){

                this.props.usuariocursoActions.getUsuarioCurso(id, usuario).then( usuariocurso=>{

                    if(usuariocurso.fechaCurso!=null){
                            usuariocurso.fechaCurso= new moment(usuariocurso.fechaCurso).format('DD/MM/YYYY');    
                    }else{
                            usuariocurso.fechaCurso= new moment().format('DD/MM/YYYY'); 
                    }

                   this.setState({"usuariocurso":usuariocurso});
                })
                .catch(error=>{
                  toastr.error(error);
                }); 
                }


                this.props.usuarioActions.getUsuarioCombo(13,usuario).then( ()=>{ 

                }) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 


        })
        .catch(error=>{
          toastr.error(error);
        });    
		
    }
    
    handleFile=(event, data)=> {
        let tamano;
        let constancia = this.state.constancia;
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        //console.log(file);
        if (!file){
            constancia.fileReg = '';
            constancia.imagePreviewUrl='';

            this.setState({"fileReg": ''});
            this.setState({"constancia": constancia});
            return;
        }


        if(event.target.files[0].size<=(1024*1024)*2){
            constancia['fileReg'] = event.target.files[0];
            constancia['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            this.setState({"fileReg": '1'});
            this.setState({"constancia": constancia});
            
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            constancia.fileReg = '';
            constancia.imagePreviewUrl='';
            this.setState({"fileReg": ''});
            this.setState({"constancia": constancia});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+"Mb. No se permiten imagnees mayores a 2 Mb!!!");
            return;
        } 
         
     }
    
    

    handleChange=(event, data)=> {

        let usuariocurso = this.state.usuariocurso;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		usuariocurso[field[0]]= value;
		else{
             if(!usuariocurso[field[0]]){
                    usuariocurso[field[0]]={}
                }
			usuariocurso[field[0]][field[1]]= value;
		}
        
		
        this.setState({"usuariocurso": usuariocurso});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let usuariocurso=this.state.usuariocurso;
              
        if(!validations.requerido(usuariocurso.usuarioId)){
            errors.usuarioId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(usuariocurso.nombreCurso)){
            errors.nombreCurso=true;
            formIsValid=false;
        }
       
       
        if(!validations.requerido(usuariocurso.fechaCurso)){
            errors.fechaCurso=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }


    fechas=(fechasArreglo, fechasCadena)=>{
    
        /*
            let pagosLista = this.state.pagosLista;
            let index  = pagosLista.findIndex(pago=>pago.id == id);
            pagosLista[index].fechaPago = fechasArreglo;
            let pago = Object.assign({}, pagosLista[index]);
            pago.fechaPago = new moment(pago.fechaPago).format('DD/MM/YYYY');
        */
        
            let usuariocurso = this.state.usuariocurso;
            usuariocurso.fechaCurso = fechasCadena;
            usuariocurso.fechadayJs = fechasArreglo;
            //new moment(fechasCadena).format("MM-DD-YYYY");
            //this.state.nuevo.fechaInicioExamen[0].format("DD-MM-YYYY");
            this.setState({usuariocurso:usuariocurso});
    }

    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        let newState=Object.assign({}, this.state.usuariocurso);
        
        /*
        if(moment.isMoment(newState.fechaCurso)){
            newState.fechaCurso = new moment(newState.fechaCurso).format('YYYY-MM-DD');
        }else{
            newState.fechaCurso = moment(newState.fechaCurso, 'DD/MM/YYYY'); 
            newState.fechaCurso = new moment(newState.fechaCurso).format('YYYY-MM-DD');
        }
        */
         newState.fechaCurso = dayjs(newState.fechadayJs).format('YYYY-MM-DD');
        
        this.props.usuariocursoActions.save(newState, this.props.user).then((usuariocurso) => {
            toastr.success("Registro guardado!!!.");
            
            
            
            var file = this.state.constancia.fileReg;


            if(file instanceof File){

                var form_data = new FormData();
                form_data.append('file', file);
                form_data.append('usuarioCursoId', usuariocurso.id);

                this.props.usuariocursoActions.saveImagen(form_data, this.props.user).then((imagen) => {

                    toastr.success("Imagen guardada correctamente!!!.");

                }).catch(error=>{
                  toastr.error(error.responseJSON.message);
                });

            }
            
            this.props.navigate(-1);
            
        });
        
    }
    

    

       
    render() {	
          
            let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <UsuarioCursoForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.usuariocurso}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    fechas={this.fechas}
                    usuarioCombo={genericFormattedForDropdown(this.props.usuarioCombo)}
                    onHandleFile={this.handleFile}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        usuarioCombo:state.usuarioCombo,
        strings:state.strings, 
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        usuariocursoActions: bindActionCreators(usuariocursoActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch)
	};
}

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageUsuarioCursoForm));